
(() => {
  const KEY = 'op_sport_favorites_v1';
  const lang = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  const I18N = {
    fr:{champOn:'Championnat suivi',eventOn:'Dans mes favoris',champOff:'Suivre ce championnat',eventOff:'Ajouter aux favoris',remove:'Retirer',add:'Ajouter',fromFav:'des favoris',toFav:'aux favoris'},
    en:{champOn:'Championship followed',eventOn:'In my favorites',champOff:'Follow this championship',eventOff:'Add to favorites',remove:'Remove',add:'Add',fromFav:'from favorites',toFav:'to favorites'},
    de:{champOn:'Meisterschaft gefolgt',eventOn:'In meinen Favoriten',champOff:'Dieser Meisterschaft folgen',eventOff:'Zu Favoriten',remove:'Entfernen',add:'Hinzufügen',fromFav:'aus Favoriten',toFav:'zu Favoriten'},
    es:{champOn:'Campeonato seguido',eventOn:'En mis favoritos',champOff:'Seguir este campeonato',eventOff:'Añadir a favoritos',remove:'Quitar',add:'Añadir',fromFav:'de favoritos',toFav:'a favoritos'},
    it:{champOn:'Campionato seguito',eventOn:'Nei miei preferiti',champOff:'Segui questo campionato',eventOff:'Aggiungi ai preferiti',remove:'Rimuovi',add:'Aggiungi',fromFav:'dai preferiti',toFav:'ai preferiti'},
    nl:{champOn:'Kampioenschap gevolgd',eventOn:'In mijn favorieten',champOff:'Dit kampioenschap volgen',eventOff:'Aan favorieten toevoegen',remove:'Verwijderen',add:'Toevoegen',fromFav:'uit favorieten',toFav:'aan favorieten'}
  };
  const tr = I18N[lang] || I18N.fr;

  const empty = () => ({ events: [], championships: [], items: {} });

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!raw || typeof raw !== 'object') return empty();
      return {
        events: Array.isArray(raw.events) ? raw.events : [],
        championships: Array.isArray(raw.championships) ? raw.championships : [],
        items: raw.items && typeof raw.items === 'object' ? raw.items : {}
      };
    } catch (_) {
      return empty();
    }
  };

  const write = (data) => {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (_) {}
    window.dispatchEvent(new CustomEvent('op:sport-favorites-changed', { detail: data }));
  };

  const has = (type, id) => {
    const data = read();
    return (type === 'championship' ? data.championships : data.events).includes(id);
  };

  const toggle = (type, id, meta = {}) => {
    if (!id) return false;
    const data = read();
    const key = type === 'championship' ? 'championships' : 'events';
    const set = new Set(data[key]);
    const active = !set.has(id);
    if (active) {
      set.add(id);
      data.items[type + ':' + id] = {
        type, id,
        name: meta.name || '',
        url: meta.url || '',
        savedAt: new Date().toISOString()
      };
    } else {
      set.delete(id);
      delete data.items[type + ':' + id];
    }
    data[key] = Array.from(set);
    write(data);
    return active;
  };

  const syncButton = (button) => {
    const type = button.hasAttribute('data-favorite-championship') ? 'championship' : 'event';
    const id = button.dataset.favoriteId || '';
    const active = has(type, id);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    const icon = button.querySelector('span[aria-hidden="true"]');
    if (icon) icon.textContent = active ? '♥' : '♡';
    const label = button.querySelector('[data-favorite-label]');
    if (label) {
      label.textContent = active
        ? (type === 'championship' ? tr.champOn : tr.eventOn)
        : (type === 'championship' ? tr.champOff : tr.eventOff);
    }
    const name = button.dataset.favoriteName || '';
    button.title = active ? tr.remove + ' ' + tr.fromFav : tr.add + ' ' + tr.toFav;
    button.setAttribute('aria-label', (active ? tr.remove : tr.add) + ' ' + name + ' ' + (active ? tr.fromFav : tr.toFav));
  };

  const syncAll = () => {
    document.querySelectorAll('[data-favorite-event],[data-favorite-championship]').forEach(syncButton);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-favorite-event],[data-favorite-championship]');
    if (!button) return;
    const type = button.hasAttribute('data-favorite-championship') ? 'championship' : 'event';
    toggle(type, button.dataset.favoriteId || '', {
      name: button.dataset.favoriteName || '',
      url: button.dataset.favoriteUrl || ''
    });
    syncAll();
  });

  window.addEventListener('op:sport-favorites-changed', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  window.OPSportFavorites = { get: read, has, toggle };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();
